import { GROUP_ID_VERSION_PARAMETER } from 'legacy/lut/components/widgets/public/partner360/ELT/configs'

import { Nullable } from 'clickNgo/models/utils'
import { deleteParamsFromUrl, getUrlParams, getUrlWithParams } from 'core-components/helpers/url'

export const getFormLink = (partnerId: string, fYear: number, groupUID?: Nullable<string>) => {
  const urlParamsForDeleting = Object.keys(getUrlParams()).filter((param) => param != 'page')
  const linkWithoutDeletedParams = deleteParamsFromUrl(urlParamsForDeleting)
  const params = { page: 'jbp-elt-form', pid: partnerId, fYear }
  if (groupUID) {
    params[GROUP_ID_VERSION_PARAMETER] = groupUID
  }
  return getUrlWithParams(params, linkWithoutDeletedParams)
}
